module.exports = __webpack_public_path__ + "static/media/Level_9.72011e53.png";